{
	"imprintTitle": "Импресум",
	"termsAndConditionsTitle": "Общи условия",
	"privacyPolicyTitle": "Политика за поверителност",
	"openSourceAttributionTitle": "Признание за отворен код"
}
